export default __webpack_public_path__ + "static/media/Autoscaling.27b861e5.png";